<template>
  <div class="grid-view">
    <div class="main-content">
      <search-item
        config-module="320010"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <!--导出Excel-->
          <el-button type="primary" @click="exportBtnClickHandler()">{{ $t('CargoMsg.Cargo_DataExport') }}</el-button>
          <!--  订舱  -->
          <el-menu
            v-show="combinedManifest"
            text-color="#404144"
            active-text-color="#404144"
            mode="horizontal"
            class="el-menu-button el-button el-button--primary el-button--mini"
            style="width: 90px;vertical-align: top"
            @select="toBooking"
          >
            <el-submenu index="index" :disabled="!bookingBtn">
              <span slot="title" class="el-menu-btn-text">{{ $t('SeaExport.EDIBooking') }}</span>
              <el-submenu index="original">
                <template slot="title">{{ $t('SeaExport.Original') }}</template>
                <el-menu-item index="API0" :disabled="!bookingEDIApiOpen">API</el-menu-item>
                <el-menu-item index="FTP1">FTP</el-menu-item>
              </el-submenu>
              <el-submenu index="correct">
                <template slot="title">{{ $t('SeaExport.Correct') }}</template>
                <el-menu-item index="FTP0">FTP</el-menu-item>
                <el-menu-item index="API1" :disabled="!bookingEDIApiOpen">API</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
        </div>
      </search-item>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          config-module="320010"
          :grid-options="gridOptions"
          :side-bar="{ toolPanels: ['columns', 'filter'], visible: false }"
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-params.sync="gridParams"
          :check-main-record="false"
          :deselect-main-record="false"
          style="width: 100%;"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="320010"
          :total="total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toAdvancedQuery()"
        />
      </div>
    </div>

    <!-- 通用选择弹窗 -->
    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="selectorDialogCallback"
    />

    <!-- EDI报文结果预览页弹窗组件 -->
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
    />
    <error-log-dialog
      :visible.sync="errorLogDialog.visible"
      :error-log="errorLogDialog.errorLog"
    />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="{}"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <api-popup
      :visible.sync="apiPopup.visible"
      :title="apiPopup.title"
      :interface-type="apiPopup.interfaceType"
      :interface-array="apiPopup.interfaceArray"
      @selectedApi="selectedApiCallback"
    />

  </div>
</template>

<script>
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { findSeaImportLCLMoreJob, findSeaImportJobByNo, queryLastModifyBookingByDay } from '@/api/SeaImport/seaImportJob'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import jobDetailIcon from '@/assets/job-detail.png'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { getEDITemplate } from '@/api/sysManage/baseConfig/ediTemplate'
import { ModelMap } from '@/class/cargo/model/parameters/ModelMap'
import * as ediApi from '@/api/seaExport/edi'
import { cache, cacheName } from '@/utils/cacheManager'
import dialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector'
import messagePreviewDialog from '@/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import ApiPopup from '@/views/cargo/v0/SeaExport/components/edi/apiPopup.vue'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import { getGridSelected } from '@/utils/agGrid'
import errorLogDialog from '@/views/cargo/v0/SeaExport/components/edi/errorLogDialog'
// import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
// import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'

export default {
  name: 'SeaEdiView',
  components: {
    ApiPopup,
    cargoTemplateSelectorDialog,
    cargoUserSelect,
    CargoAdvanceSelect,
    CargoGridShowBigContent,
    dialogSelector, messagePreviewDialog,
    searchItem,
    errorLogDialog
  },
  data() {
    return {
      ColumnUtils,
      CrmCustomerConstants,
      selectTypeNames: TYPE_NAMES,
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      filterJson: {},
      isAdvancedQuery: false, // 是否为高级查询
      total: 0,
      documentManage: new DocumentManage(),
      selectedJob: null,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.BusinessNo'),
          colId: 'jobNo',
          field: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              const methodPath = this.documentManage.getPath('showBusinessInfo')
              return `<span>${params.value}<img src="${jobDetailIcon}" height="16" width="16" style="vertical-align: sub;margin-left:3px;cursor:pointer" onclick="${methodPath}(event)"/></span>`
            }
          }
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: (event) => {
          this.onGridRowClicked(event)
        },
        // 单选（勾选框或者其他列，都会触发）
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          const selectedNode = nodes[event.rowIndex] || null
          if (selectedNode) {
            this.rowClicked({ data: selectedNode.data })
          } else {
            this.rowClicked(null)
          }
        },
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ConsignationRelationNumber'),
          colId: 'trustFromJob',
          field: 'trustFromJob',
          width: 120
        }, {
          headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'),
          colId: 'relatedJob',
          field: 'relatedJob',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          colId: 'customerId',
          field: 'customerId',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CustomerType, 'typeId', params.value, 'chineseName')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.ContractStatus'),
          colId: 'contractStatus',
          field: 'contractStatus',
          width: 120
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          colId: 'cargoSalesId',
          field: 'cargoSalesId',
          hide: true,
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.Hbl2'),
          field: 'hbl',
          colId: 'hbl',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Mbl2'),
          field: 'mbl',
          colId: 'mbl',
          width: 120
        }, {
          headerName: this.$t('SeaExport.PortOfLoading'),
          colId: 'loadingPortCode',
          field: 'loadingPortCode',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.PortOfDischarge'),
          colId: 'dischargingPortCode',
          field: 'dischargingPortCode',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.NominatedAgent'),
          field: 'designationAgent',
          colId: 'designationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_3') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          colId: 'chargeWeight',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.PortOfLoadingAgent'),
          field: 'destinationAgent',
          colId: 'destinationAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_2') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.TheFirstVessel'),
          field: 'vessel',
          colId: 'vessel',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Voyage'),
          field: 'voyageFlight',
          colId: 'voyageFlight',
          width: 120
        }, {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'carryingCmp',
          colId: 'carryingCmp',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_11') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          field: 'quantityContract',
          colId: 'quantityContract',
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.Weight'),
          field: 'weightContract',
          colId: 'weightContract',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          field: 'cubageContract',
          colId: 'cubageContract',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: 'TEU',
          colId: 'teu',
          field: 'teu',
          width: 100
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          colId: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ItemNo'),
          field: 'poNo',
          colId: 'poNo',
          width: 120
        }, {
          headerName: this.$t('SeaExport.CustomerReferenceNumber'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          width: 130
        }, {
          headerName: this.$t('SeaExport.BusinessType'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          valueFormatter: (params) => {
            if (!params.data) return ''
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'containerLoadType')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          field: 'customerRefNo',
          colId: 'customerRefNo',
          width: 130
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          colId: 'tmpContainerNo',
          field: 'tmpContainerNo',
          width: 120
        }, {
          headerName: this.$t('SeaExport.OverseaCustomerService'),
          colId: 'overseaOp',
          field: 'overseaOp',
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.SolicitationType'),
          field: 'cargoSource',
          colId: 'cargoSource',
          valueFormatter: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.DateOfDeparture'),
          field: 'etd',
          colId: 'etd',
          width: 120
        }, {
          headerName: this.$t('SeaExport.DateOfArrival'),
          field: 'eta',
          colId: 'eta',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ContainerDescription'),
          field: 'containerDesc',
          colId: 'containerDesc',
          valueFormatter: (params) => {
            return ColumnUtils.containerDescLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.isShutOut'),
          field: 'shutOut',
          colId: 'shutOut',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.BillExchange'),
          field: 'bTransDate',
          colId: 'bTransDate',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.PickUpGoods'),
          field: 'bDeliverDate',
          colId: 'bDeliverDate',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.CustomJobType'),
          field: 'customJobType',
          colId: 'customJobType',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
          },
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.BillExchangeDate'),
          field: 'transDate',
          colId: 'transDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'bookingAgent',
          colId: 'bookingAgent',
          valueFormatter: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
          },
          width: 200
        }, {
          headerName: this.$t('SeaExport.ActualDateOfArrival'),
          field: 'ata',
          colId: 'ata',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150
        }, {
          headerName: this.$t('SeaExport.Storage'),
          field: 'warehousing',
          colId: 'warehousing',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.Devanning'),
          field: 'parts',
          colId: 'parts',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.DeliveryToDoor'),
          field: 'landTransportation',
          colId: 'landTransportation',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.CustomsDeclaration'),
          field: 'customs',
          colId: 'customs',
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.DateOfCreation'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 120
        }, {
          headerName: this.$t('SeaExport.Sales'),
          field: 'sales',
          colId: 'sales',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_sales')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Accrued'),
          field: 'provisioned',
          colId: 'provisioned',
          valueFormatter: params => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          hide: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_op')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'auto_csr')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Documents'),
          field: 'dc',
          colId: 'dc',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.Status'),
          field: 'jobState',
          colId: 'jobState',
          valueFormatter: (params) => {
            return ColumnUtils.getJobStateCN(params.value)
          },
          width: 100
        }, {
          headerName: this.$t('SeaExport.ContractRateProperty'),
          field: 'bookingTerm',
          colId: 'bookingTerm',
          valueFormatter: (params) => {
            return ColumnUtils.bookingTermSILabelFunction(params.data, params.value)
          },
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.ShippingCompanyContractNo'),
          field: 'scNo',
          colId: 'scNo',
          hide: true,
          width: 150
        }, {
          headerName: this.$t('SeaExport.Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 100
        }, {
          headerName: this.$t('SeaExport.SOPStatus'),
          field: 'sopState',
          colId: 'sopState',
          width: 150,
          valueFormatterFramework: 'CargoGridShowBigContent'
        }, {
          headerName: this.$t('SeaExport.UserDefinedField1'),
          field: 'userDefinedField1',
          colId: 'userDefinedField1',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.UserDefinedField2'),
          field: 'userDefinedField2',
          colId: 'userDefinedField2',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.UserDefinedField3'),
          field: 'userDefinedField3',
          colId: 'userDefinedField3',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('SeaExport.ManageAuditStatus'),
          field: 'manageAuditStatus',
          colId: 'manageAuditStatus',
          hide: true,
          width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.manageAuditStatusLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.TradeTerms2'),
          field: 'incoTerm',
          colId: 'incoTerm',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.UserDefinedField4'),
          field: 'userDefinedField4',
          colId: 'userDefinedField4',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('SeaExport.AirlinePerson2'),
          colId: 'planner',
          field: 'planner',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 120
        }, {
          headerName: this.$t('SeaExport.OperationDate'),
          colId: 'customsDate',
          field: 'customsDate',
          width: 120
        }
      ],
      rowData: [],
      gridApi: null,
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImportJob(),
        category: '',
        data: {}
      },
      // 通用选择弹窗
      selectorDialog: {
        visible: false,
        title: '',
        rowData: [],
        callback: () => { }
      },
      // 报文预览弹窗
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      globalVar: {},
      bookingEDIApiOpen: false,
      apiPopup: { // api弹框
        visible: false,
        title: '',
        state: '',
        interfaceType: 1,
        interfaceArray: ''
      },
      configMap: new Map(),
      bookingBtn: false,
      combinedManifest: false,
      // 错误日志显示弹窗
      errorLogDialog: {
        visible: false,
        errorLog: ''
      }
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showBusinessInfo', function() {
      context.showBusinessInfo()
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.configMap = cache.config
    this.bookingEDIApiOpen = Number(this.configMap.get('BookingEDIApiOpen')) !== 0
    this.combinedManifest = Number(cache.config.get('CombinedManifest')) === 1
    this.queryLastModifyBookingByDay()
  },
  methods: {
    // 查询最近几天的业务
    queryLastModifyBookingByDay() {
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.createdBy = this.$store.getters.userId
      queryLastModifyBookingByDay(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (typeof keyword !== 'undefined') {
        this.filter.jobNo = keyword.trim()
        this.filter.pageNum = 1
      }
      this.$logger.log('this.filter', this.filter)
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      findSeaImportJobByNo(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 高级查询
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = this.addConditionsBeforeQuery(data)
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      findSeaImportLCLMoreJob(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查询之前的条件组装
    addConditionsBeforeQuery(data) {
      if (typeof data === 'undefined') return
      if (!AdvancedSearchOption.hasField('job.OP_OFFICE', data)) {
        const option = new AdvancedSearchOption(null, 'job.OP_OFFICE', this.$store.getters.currentOfficeId, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        data.push(option.formatObj2Json())
      }
      return data
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.total = Number(res.data.total)
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.gridApi.clearFocusedCell()
    },
    // 列表 业务编号旁边搜索框的打印
    showBusinessInfo(e) {
      stopBubble(e)
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      if (!this.selectedJob) return
      this.templateSelectorDialog.ctx = new SeaImportJob(this.selectedJob)
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    // 选中 勾选框触发[获取选中行]
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      if (event.node.isSelected()) {
        const node = event.data
        if (node.uuid) this.selectedJob = node
      }
    },
    // 行点击触发事件
    onGridRowClicked(event) {
      if (!event || !event.data) return
      this.selectedJob = null
      const node = event.data
      if (node.uuid) this.selectedJob = node
    },
    // 导出
    exportBtnClickHandler() {
      const allRows = this.gridApi.getModel().rowsToDisplay.filter(node => node.selected).map(node => node.data)
      const selectedJobs = []
      if (allRows && allRows.length > 0) {
        for (const row of allRows) {
          if (row.masterFlag || (!row.masterFlag && !row.lclMasterUuid)) {
            selectedJobs.push(row.uuid)
          }
        }
      }
      if (!selectedJobs || selectedJobs.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      this.ediHandler(selectedJobs)
    },
    // EDI 处理
    ediHandler(selectedJobs) {
      const self = this
      self.globalVar.jobUuids = selectedJobs
      self.globalVar.title = this.$t('SeaImport.Allocation')
      self.globalVar.editStatus = 9
      self.globalVar.ediType = 9
      self.globalVar.ediTemplate = {}
      self.globalVar.ediTemplate.defaultFileType = '.txt'
      if (parseInt(cache.config.get('useEDITemplate')) === 1) {
        self.common().showEDITemplateWin()
      } else {
        const params = {
          jobUuids: selectedJobs,
          editStatus: self.globalVar.editStatus
        }
        self.loading = getLoading()
        ediApi.getEDI(params).then(response => {
          self.commonCallback().onExportEDISuccess(response)
        }).catch(err => {
          self.commonCallback().onExportEDIFail(err)
        }).finally(() => {
          self.loading.close()
        })
      }
    },
    // EDI公共方法
    common() {
      const self = this
      // 显示EDI模板选择弹窗(selectorDialog)
      const showEDITemplateWin = () => {
        self.loading = getLoading()
        getEDITemplate({ templateType: this.globalVar.ediType }).then(result => {
          self.selectorDialog.title = self.globalVar.title
          self.selectorDialog.rowData = result.data
          self.selectorDialog.visible = true
        }).finally(() => {
          self.loading.close()
        })
      }
      // 弹出messagePreviewDialog
      const setEdiTabWindow = () => {
        self.messagePreviewDialog.params = {
          job: self.selectedJob,
          title: self.globalVar.title,
          ediType: self.globalVar.ediType,
          ediCollection: self.globalVar.ediDatas,
          ediTemplate: self.globalVar.ediTemplate
        }
        self.messagePreviewDialog.visible = true
      }
      // 获取selectedJobs & 拼接各类所需对象
      const getSelectedJobs = () => {
        if (!self.rowData || self.rowData.length < 1) {
          return
        }
        // 点击行
        const selectedJob = this.selectedJob
        if (selectedJob) {
          self.globalVar.selectedJob = selectedJob
          self.globalVar.selectedJobKeys = selectedJob.uuid
        }
        // 勾选行
        const selectedJobs = getGridSelected(self.gridOptions)
        self.globalVar.selectedJobs = selectedJobs
        if (selectedJobs && selectedJobs.length > 0) {
          self.globalVar.selectedJobKeys = selectedJobs.map(item => item.uuid)
        }
      }
      return { showEDITemplateWin, setEdiTabWindow, getSelectedJobs }
    },
    // EDI公共回调方法
    commonCallback() {
      const self = this
      // edi导出成功回调方法
      const onExportEDISuccess = async(response) => {
        if (!response || !response.data || JSON.stringify(response.data) === '{}') {
          self.$message.warning(this.$t('SeaExport.NoImportEDI'))
          return
        }
        self.globalVar.ediDatas = response.data
        self.common().setEdiTabWindow()
      }
      // edi导出失败回调方法
      const onExportEDIFail = (dataMsg) => {
        if (dataMsg instanceof Error) {
          return
        }
        const modelMap = ModelMap['ProperyLabelMap']
        const errorMsgArr = dataMsg ? dataMsg.split(';') : null
        let finalMessage = ''
        const suffixMsg = this.$t('SeaExport.ItIsEmpty') + '<br/>'
        if (errorMsgArr && errorMsgArr.length > 0) {
          errorMsgArr.forEach(errorMsg => {
            const modelField = errorMsg.split('.')
            if (modelField && modelField.length > 0) {
              const model = modelMap[modelField[0]]
              if (model) {
                finalMessage += (model[modelField[1]] + suffixMsg)
              }
            } else {
              finalMessage += errorMsg
            }
          })
        }
        if (finalMessage) {
          self.$message.error({ dangerouslyUseHTMLString: true, message: finalMessage })
        }
      }
      return { onExportEDISuccess, onExportEDIFail }
    },
    // 选择EDI模板后的回调方法
    selectorDialogCallback(row) {
      const self = this
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      const param = {}
      param.ediType = self.globalVar.ediType
      param.templateId = self.globalVar.ediTemplate.uuid
      param.jobUuids = self.globalVar.jobUuids
      param.editStatus = self.globalVar.editStatus
      param.ruleEDINos = []
      this.loading = getLoading()

      // 转移callback
      ediApi.getEDI(param).then(result => self.commonCallback().onExportEDISuccess(result))
        .catch(message => self.commonCallback().onExportEDIFail(message))
        .finally(() => {
          self.loading.close()
        })
    },
    toBooking(index) {
      this.common().getSelectedJobs()
      switch (index) {
        case 'API0':
          this.bookingEDIApi('9')
          break
        case 'API1':
          // this.bookingEDIApi('5')
          break
      }
    },
    rowClicked(event) {
      // 选中行为主票的MBL单时,event置空
      if (event) {
        const data = event.data
        if (data && Number(data.dataType) !== 1 && Number(data.dataType) !== 2) {
          event = null
        }
      }
      if (!event) {
        this.bookingBtn = false
        return
      }
      const data = event.data
      if (data.masterFlag) {
        this.bookingBtn = true
      } else {
        this.bookingBtn = data.containerLoadType !== 'LCL'
      }
      // 点击行时多选框自动勾选该行并清除其他行的勾选，此处记录点击行时选择的job对象，用以和点击行后，继续勾选其他行的多选框的job进行区分
      this.selectedJob = event.data
    },
    bookingEDIApi(state) {
      this.apiPopup.title = this.$t('SeaExport.Booking') + ' API'
      this.apiPopup.interfaceArray = this.configMap.get('BookingEDIApiOpen')
      this.apiPopup.state = state
      this.apiPopup.interfaceType = 1
      this.apiPopup.visible = true
    },
    async selectedApiCallback(row) {
      if (row) {
        const inteface = row['id'].toString()
        if (inteface === '3') { // 吉联新
          const param = {}
          param.jobUuids = this.globalVar.selectedJobKeys
          param.editStatus = parseInt(this.apiPopup.state)
          param.sendType = EdiType.BOOKING_EDI_TYPE.code // 订舱
          param.lob = 'SI'
          const loading = getLoading4Cxt()
          ediApi.getJiLianStarAPI(param).then(result => this.apiSuccess(result, true)).catch(message => {
            this.$message.error(message)
          }).finally(() => {
            loading.close()
          })
        }
      }
    },
    /**
     * 成功
     */
    apiSuccess(event, isJlx = false) {
      const o = event.data
      if (o) {
        const success = o.isSuccess
        if (success) {
          if (o.msg) {
            this.errorLogDialog.errorLog = o.msg
            this.errorLogDialog.visible = true
            return
          }
          this.$message.success(this.$t('SeaExport.RequestSuccessful'))
        } else {
          console.log('错误弹出----------------------------')
          const text = o.text.toString()
          const textStr = isJlx ? text : text.substring(0, text.length - 5) + text.substring(text.length - 5, text.length).replace(';', '')
          this.errorLogDialog.errorLog = textStr
          this.errorLogDialog.visible = true
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
